module.exports = __webpack_public_path__ + "static/htbs-en-823346b3f07722045c4f2321d31c3c8f.mp3";